import { Component } from 'react';

class V1GameRedirector extends Component {

    componentDidMount(){
        window.location.hostname = 'puzzle-v1.nes.science';
    }

    render(){
        return(<span></span>)
    }
}

export default V1GameRedirector
